import * as Business           from '../../business';
import * as UI                 from '../../ui';
import * as User               from '../../user';
import { compose }             from 'redux';
import { connect }             from 'react-redux';
import { Fragment }            from 'react';
import { useClient }           from './google_auth';
import FetchFromServer         from '../../components/fetch_from_server';
import GoogleAuth              from './google_auth';
import Navbar                  from '../../components/navbar';
import React                   from 'react';
import VerificationOptionsView from './verification_options_view';


export default connect(
  (state, { businessID }) => ({
    userName:       User.getUserName(state),
    business:       Business.getBusiness(state, businessID),
    googleLocation: Business.getGoogleLocation(state, businessID),
    statuses:       Business.getBusinessStatuses(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:                 compose(dispatch, Business.loadBusiness, () => (businessID)),
    updateGoogleLocation: compose(dispatch, Business.updateGoogleLocation, googleLocation => ({ businessID, googleLocation })),
    progressStart:        () => dispatch(UI.progressStart()),
    progressEnd:          () => dispatch(UI.progressEnd())
  })
)(GmbVerifyPage);

export function GmbVerifyPage({
  statuses,
  load,
  userName,
  business,
  verificationAddress,
  googleLocation,
  updateGoogleLocation,
  progressStart,
  progressEnd,
  navigateBackTo
}) {

  return (
    <Fragment>
      <Navbar title="Verify Your Location"/>
      <FetchFromServer statuses={statuses} load={load} className="settings google-verify">
        <GoogleAuth requireReauthorization={false}>
          <GoogleAuth.Loading>
            <GoogleAuth.LoadingView/>
          </GoogleAuth.Loading>
          <GoogleAuth.Failed>
            <GoogleAuth.FailedView/>
          </GoogleAuth.Failed>
          <GoogleAuth.SignedOut>
            <AnonymousView/>
          </GoogleAuth.SignedOut>
          <GoogleAuth.SignedIn>
            <AuthedView {...{
              userName,
              business,
              verificationAddress,
              googleLocation,
              updateGoogleLocation,
              progressStart,
              progressEnd,
              navigateBackTo
            }}/>
          </GoogleAuth.SignedIn>
        </GoogleAuth>
      </FetchFromServer>
    </Fragment>
  );
}


function AuthedView(props) {
  const { googleLocation } = props;
  if (!googleLocation)
    return null;

  return (
    <VerificationOptionsView {...props}/>
  );
}


function AnonymousView() {
  const client = useClient();

  function onClickSignIn() {
    client.signIn();
  }

  return (
    <Fragment>
      <div className="list block inset">
        <h3>Verify Your Location</h3>
        <p>To verify your location, please sign in with your Google account.</p>
      </div>
      <div className="list block inset google-signin">
        <p>
          <button className="button button-fill" onClick={onClickSignIn}>
            Sign in with your Google Account
          </button>
        </p>
      </div>
    </Fragment>
  );
}
